(() => {
  const initFaqToggles = (scope = document) => {
    const toggles = [];

    if (scope.matches?.('[data-domoxa-faq-toggle]')) toggles.push(scope);
    toggles.push(...(scope.querySelectorAll?.('[data-domoxa-faq-toggle]') || []));

    toggles.forEach((toggle) => {
      if (toggle.dataset.domoxaFaqToggleInitialized === 'true') return;
      toggle.dataset.domoxaFaqToggleInitialized = 'true';

      toggle.addEventListener('click', () => {
        const root = toggle.closest('[data-domoxa-faq]');
        if (!root) return;

        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        root.querySelectorAll('[data-domoxa-faq-extra]').forEach((item) => {
          item.hidden = expanded;
        });
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');

        const label = toggle.querySelector('[data-domoxa-faq-toggle-label]');
        if (label) {
          label.textContent = expanded
            ? toggle.dataset.showMoreLabel || 'Voir toutes les questions'
            : toggle.dataset.showLessLabel || 'Voir moins de questions';
        }
      });
    });
  };

  initFaqToggles();

  document.addEventListener('shopify:section:load', (event) => {
    initFaqToggles(event.target);
  });
})();
